import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
     page: {
        flexDirection: 'column',
        width: "100%"
    },
    textxView: {
      marginLeft: 20,
      marginTop: 40
    },
     btn: {
        borderWidth: 1,
        borderRadius: 16,
        borderColor: "rgb(83, 83, 83)"
    },
     btnText: {
        fontSize: 20,
        fontWeight: '600',
        textAlign: 'center'
    },
     textGrey: {
        color: '#535353',
        fontFamily: 'Montserrat',
    },
    text: {
        fontSize: 14,
        color: '#000006',
        fontWeight: '500',
        fontFamily: 'Montserrat',
        marginBottom: 10,
        marginLeft: 5,
    },
    buttonDefault: {
        backgroundColor: 'red'
    }, 
    buttonTextMobile: {
        color: '#535353',
    },
});
